import { useEnsurePushSubscription } from "../hooks/use-ensure-push-subscription"
import { usePushPromptDrawer } from "../hooks/use-push-prompt"
import { PermissionDrawer } from "./permission-drawer"

export function PushPromptDrawer() {
  useEnsurePushSubscription()
  const { open, onClose } = usePushPromptDrawer()
  return <PermissionDrawer open={open} onClose={onClose} />
}
